import { useFeatureFlag } from './useFeatureFlag'

/**
 * This hook is used to for a payment traffic routing change rollout.
 * When the rollout is complete, the hook can be removed.
 */
export const usePaymentRouteHeader = (): Record<string, string> => {
  const commonPaymentRoutingEnabled = useFeatureFlag('cash-web-payment-route-common-enabled')

  // The X-Payment-Route header is used to indicate the payment route on the server.
  // When "COMMON" is used, it will be routed with app traffic to the Fiatly service.
  return commonPaymentRoutingEnabled ? { 'X-Payment-Route': 'COMMON' } : {}
}
